/**
 * CardAction1 시나리오
 * 워크플로우 기반 대시보드 - action1.svg
 */

import { ReactComponent as Action1SVG } from "@/assets/animations/action1.svg";
import type { MotionScenario } from "../types";

export const cardAction1Scenario: MotionScenario = {
  svgComponent: Action1SVG,

  transitionSpeed: 1500, // 1.5초 간격

  repeat: {
    mode: "once", // 한 번만 실행
  },

  viewBoxAnimation: {
    duration: 800,
    easing: "easeInOut",
  },

  scenes: [
    // Scene 0: action0
    {
      id: 0,
      name: "action0",
      elements: [
        {
          selector: 'g[data-name="action0"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action1"]',
          opacity: 1, // action1은 항상 표시
        },
         {
          selector: 'g[data-name="action2"]',
          opacity: 0, 
        },
        {
          selector: 'g[data-name="action3"]',
          opacity: 0, 
        },
        {
          selector: 'g[data-name="action4"]',
          opacity: 0, 
        },

        {
          selector: 'g[data-name="action2_3"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="action3_4"]',
          opacity: 0,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="action0"]',
        zoom: 0.3, // 약 3.3배 확대
      },
      glowEffect: true,
      glowSelector: 'g[data-name="action0"]',
    },

    // Scene 1: action1 (줌 없음, 항상 표시)
    {
      id: 1,
      name: "action1",
      elements: [
        {
          selector: 'g[data-name="action0"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action1"]',
          opacity: 1,
        },
      ],
     viewBox: {
        centerSelector: 'g[data-name="action0"]',
        zoom: 0.3, // 약 3.3배 확대
      },
      glowEffect: true,
      glowSelector: 'g[data-name="action1"]',
    },

    // Scene 2: action2
    {
      id: 2,
      name: "action2",
      elements: [
        {
          selector: 'g[data-name="action0"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action1"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action2"]',
          opacity: 1,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="action2"]',
        zoom: 0.4, // 약 2.5배 확대
      },
      glowEffect: true,
      glowSelector: 'g[data-name="action2"]',
    },

    // Scene 3: action3
    {
      id: 3,
      name: "action3",
      elements: [
        {
          selector: 'g[data-name="action0"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action1"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action2"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action3"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action2_3"]',
          opacity: 1,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="action3"]',
        zoom: 0.4,
      },
      glowEffect: true,
      glowSelector: 'g[data-name="action3"]',
    },

    

    // Scene 4: action4
    {
      id: 4,
      name: "action4",
      elements: [
        {
          selector: 'g[data-name="action0"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action1"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action2"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="action3"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action4"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="action2_3"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="action3_4"]',
          opacity: 1,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="action4"]',
        zoom: 0.4,
      },
      glowEffect: true,
      glowSelector: 'g[data-name="action4"]',
    },
    
  
  ],
  
};
